import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static get values() {
        return {
            images: Object,
        }
    }

    connect() {
        const images = this.element.querySelectorAll('img');
        this.imagesValue = images;
    }
}
